import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
    >
      <Circle
        cx={60}
        cy={60}
        r={57}
        fill="#04B528"
        stroke="#fff"
        strokeWidth={6}
      />
      <Path
        d="M82.225 43.333L51.669 73.89 37.78 59.999"
        stroke="#fff"
        strokeWidth={7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default SvgComponent
